import { usePaymentTask } from '@/hooks/api/1000_payment_task';
import { TeamMemberLogic } from '@/hooks/api/models/logics';
import { toastError } from '@/lib/toast';
import { useCurrentPaymentTask } from '@/providers/PaymentTaskProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

type Props = { children?: React.ReactNode };

export const RequirePaymentTask = (props: Props) => {
  const location = useLocation();
  const { meTeamMember } = useCurrentTeamMember();
  const { identifier, team_id, purchase_order_id, payment_task_id } = useParams();
  const { data, status } = usePaymentTask({
    identifier: identifier!,
    team_id: Number(team_id!),
    purchase_order_id: Number(purchase_order_id!),
    id: Number(payment_task_id!),
  });
  const { paymentTask, setPaymentTask } = useCurrentPaymentTask();

  useEffect(() => {
    if (data) {
      setPaymentTask((_) => data);
    }
  }, [data]);

  if (status == 'error') {
    toastError('アクセス出来ませんでした。');
    return <Navigate replace to={`/w/${identifier}`} />;
  }

  // backoffice権限のみの場合
  if (meTeamMember && TeamMemberLogic.hasBackofficeOnlyRole(meTeamMember!)) {
    // urlがプロジェクト配下のurlの場合は、backoffice配下のurlに遷移
    if (location.pathname.startsWith(`/w/${identifier}/teams/`)) {
      return <Navigate replace to={`/w/${identifier}/backoffice/teams/${team_id}/purchase_orders/${purchase_order_id}/payment_tasks/${payment_task_id}`} />;
    }
  }

  if (paymentTask) {
    return <>{props.children}</>;
  }

  return <></>;
};
